<div [@routerTransition]>
    <div class="content">
        <div style="height: 100vh" class="d-flex flex-column justify-content-center">
            <p class="text-center">{{l("Support_QuickLinkMissing")}}</p>
        </div>
    </div>
</div>
